module.exports = __webpack_public_path__ + "img/science.81377403.jpg";